import React, {Component} from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import DefaultModal from "../../invoice/DefaultModal";
import Select from "../../../local_node_modules/react-select";
import {decideBankType, deepCopyObject, getNaceCodes, showAxiosError} from "../../../helper/helper";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import createIBANMask from "text-mask-addon-iban";
import {request} from "../../../helper/APIUtils";
import {CustomerBankType} from "../../../helper/enums";
import Alert from "react-s-alert";
import {isValidChemistInformation} from "../../../common/componentValidation";

class ChemistInformationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chemistInformation: {
                vknTckn: "",
                formattedName: "",
                givenName: "",
                familyName: "",
                naceCodes: [],
                corporateMail: "",
                city: "",
                taxOffice: "",
                sorumluCepTel: "",
                sorumluEPosta: "",
                bankList: [
                    {bankName: "", iban: "", type: CustomerBankType.SGK},
                    {bankName: "", iban: "", type: CustomerBankType.KAMU},
                    {bankName: "", iban: "", type: CustomerBankType.OTHER}
                ],
                application: "",
                applicationOther: ""
            },
            taxOfficeList: [],
            filteredTaxOfficeList: [],
            cityList: [],
            bankList: [],
            disableSaveButton: false,
            disableFormattedName: false,
            applicationList: [
                {value: "FARMAKOM", label: "Farmakom"},
                {value: "TEBEOS", label: "Tebeos"},
                {value: "ECZANEM", label: "Eczanem"},
                {value: "TRIA", label: "Tria"},
                {value: "HAVAN", label: "Havan"},
                {value: "RXMEDYA", label: "RxMedya"},
                {value: "ILON", label: "İlon"},
                {value: "BOTANIK", label: "Botanik"},
                {value: "BAYT", label: "Bayt"},
                {value: "EBILGI", label: "E-bilgi"},
                {value: "FARMASIS", label: "Farmasis"},
                {value: "RXPHARMA", label: "RxPharma"},
                {value: "DIGER", label: "Diğer"}
            ]
        }
    }

    componentDidMount = async () => {
        let self = this;
        await request({
            url: "/chemist-information/getList",
            method: "get"
        }).then(async (response) => {
            if (response && response.data) {
                let chemistInformation = deepCopyObject(self.state.chemistInformation);
                let disableFormattedName = deepCopyObject(self.state.disableFormattedName);
                let applicationList = deepCopyObject(self.state.applicationList);
                if (response.data.customer) {
                    let customer = response.data.customer;
                    chemistInformation.vknTckn = customer.vknTckn;
                    chemistInformation.formattedName = customer.formattedName;
                    chemistInformation.givenName = customer.givenName;
                    chemistInformation.familyName = customer.familyName;
                    chemistInformation.corporateMail = customer.corporateMail;
                    chemistInformation.city = customer.city;
                    chemistInformation.taxOffice = customer.taxOffice;
                    chemistInformation.sorumluCepTel = customer.sorumluCepTel;
                    chemistInformation.sorumluEPosta = customer.sorumluEPosta;
                    chemistInformation.naceCodes = customer.naceCodeList;

                    if (customer.commercialSoftware === "" || customer.commercialSoftware === undefined || customer.commercialSoftware === null) {
                        chemistInformation.application = customer.commercialSoftware;
                    } else {
                        const applicationFilter = applicationList.filter(f => f.value === customer.commercialSoftware);
                        if (applicationFilter.length > 0) {
                            chemistInformation.application = applicationFilter[0].value;
                        } else {
                            chemistInformation.application = "DIGER";
                            chemistInformation.applicationOther = customer.commercialSoftware;
                        }
                    }

                    if (chemistInformation.naceCodes.length === 0) {
                        const naceCode = await getNaceCodes("477301");
                        naceCode && naceCode.options.map(d => {
                            chemistInformation.naceCodes.push({
                                id: d.value,
                                code: d.customValue,
                                description: d.description,
                                label: d.code + ' , ' + d.description,
                                value: d.id,
                                customValue: d.code
                            })
                        });
                        // chemistInformation.naceCodes = naceCode ? self.prepareNaceCodesSelectData(naceCode.options) : [];
                        self.onChangeNaceCodes(naceCode ? naceCode.options : []);
                    }

                    disableFormattedName = customer.vknTckn.length === 10;
                }
                self.setState({
                    bankList: response.data.bankList,
                    cityList: response.data.cityList,
                    taxOfficeList: response.data.taxOfficeList,
                    chemistInformation: chemistInformation,
                    disableFormattedName: disableFormattedName
                }, () => self.onChange("city", chemistInformation.city));
            }
        }).catch(async (exception) => {
            showAxiosError(exception)
        });
    }

    prepareNaceCodesSelectData = (naceCodeList = []) => {
        let selectData = [];
        naceCodeList.map((item) => {
            selectData.push({
                value: item.id,
                customValue: item.code,
                description: item.description,
                label: item.code + ' , ' + item.description
            })
        });
        return selectData;
    }

    onChangeNaceCodes = (data) => {
        let self = this;
        let chemistInformation = deepCopyObject(self.state.chemistInformation);
        let selectedItemList = [];
        data.map(d =>
            selectedItemList.push({
                id: d.value,
                code: d.customValue,
                description: d.description,
                label: d.code + ' , ' + d.description,
                value: d.id,
                customValue: d.code
            })
        );
        chemistInformation.naceCodes = selectedItemList;
        self.setState({chemistInformation: chemistInformation});
    }

    onChange = (name, value) => {
        let self = this;
        let chemistInformation = deepCopyObject(self.state.chemistInformation);
        chemistInformation[name] = value;
        self.setState({chemistInformation});
        if (name === "city") {
            let taxOfficeList = self.state.taxOfficeList;
            let filteredTaxOfficeList = taxOfficeList.filter(to => to.city === value);
            let find = filteredTaxOfficeList.find(t => t.vdName === chemistInformation["taxOffice"]);
            chemistInformation["taxOffice"] = find ? find.vdName : "";
            self.setState({filteredTaxOfficeList, chemistInformation});
        }
    }

    onChangeBank = (name, value, type) => {
        let self = this;
        let chemistInformation = deepCopyObject(self.state.chemistInformation);
        let bankList = chemistInformation.bankList;
        for (let bank of bankList) {
            if (bank.type === type) {
                bank[name] = value;
                break;
            }
        }
        chemistInformation.bankList = bankList;
        self.setState({chemistInformation: chemistInformation});
    }

    save = () => {
        let self = this;
        let chemistInformation = deepCopyObject(self.state.chemistInformation);
        let valid = isValidChemistInformation(chemistInformation, self.state.cityList, self.state.filteredTaxOfficeList);
        if (valid.valid) {
            request({
                url: "/chemist-information/saveChemistInformation",
                method: "post",
                data: chemistInformation
            }).then((response) => {
                Alert.success("Bilgileriniz başarılı bir şekilde güncellenmiştir.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000,
                    html: false
                });
                self.props.toggle();
            }).catch((exception) => {
                showAxiosError(exception);
            });
        } else {
            Alert.error(valid.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: true
            });
        }
        self.setState({disableSaveButton: false});
    }

    renderBankInput = () => {
        let self = this;
        return (
            self.state.chemistInformation.bankList.map((bank, index) =>
                <Row key={index}>
                    {index === 0 &&
                        <Col sm={12}>
                            <h2 className="h2-withOutMargin" style={{paddingTop: '30px'}}><b>Banka Bilgileri</b></h2>
                        </Col>
                    }

                    <Col sm={6}>
                        <FormGroup row>
                            <Label
                                sm={10}
                                for={bank.type + "_BankName"}>{`Banka Adı (${decideBankType(bank.type)}) *`}</Label>
                            <Col sm={12}>
                                <Select className="selected-control"
                                        type="text"
                                        name={bank.type + "_BankName"}
                                        placeholder="Seçiniz..."
                                        value={bank.bankName}
                                        options={self.state && self.state.bankList && self.state.bankList.map(b => ({
                                            value: b.name,
                                            label: b.name,
                                        }))}
                                        onChange={(e) => self.onChangeBank("bankName", e.value, bank.type)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm={6}>
                        <FormGroup row>
                            <Label sm={10} for={bank.type + "_Iban"}>IBAN *</Label>
                            <Col sm={12}>
                                <MaskedInput className="form-control"
                                             mask={createIBANMask('TR')}
                                             placeholder={"TR__ ____ ____ ____ ____ ____ __"}
                                             type="text"
                                             name={bank.type + "_Iban"}
                                             value={bank.iban}
                                             onChange={(e) => self.onChangeBank("iban", e.target.value.replace(/\s/g, ''), bank.type)}/>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>)
        )
    }

    render() {
        return (
            <DefaultModal
                disabled={this.state.disableSaveButton}
                isOpen={this.props.show}
                title="Müşteri bilgi güncelleme"
                size="lg"
                cancelBtnText="Kapat"
                onCancel={this.props.toggle}
                confirmBtnText="Kaydet"
                onConfirm={() => {
                    this.setState({disableSaveButton: true}, () => this.save())
                }}
            >
                <Col sm={12}>
                    <Row sm="12">
                        <Col sm={12}>
                            <h2><b>Değerli Müşterimiz, Portal Bilgi Güncellemesi kapsamında, Mevcut bilgilerinizi
                                kontrol etmenizi ve eksik/hatalı bilgileri düzeltmenizi rica ederiz.</b></h2>
                        </Col>
                    </Row>

                    <Row sm="12">
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="vknTckn">Vkn/Tckn: </Label>
                                <Col sm={12}>
                                    <Input type="text"
                                           name="vknTckn"
                                           disabled={true}
                                           value={this.state.chemistInformation.vknTckn}
                                           onChange={(e) => this.onChange("vknTckn", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="formattedName">Eczane Adı: </Label>
                                <Col sm={12}>
                                    <Input type="text"
                                           name="formattedName"
                                           disabled={this.state.disableFormattedName}
                                           value={this.state.chemistInformation.formattedName}
                                           onChange={(e) => this.onChange("formattedName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row sm="12">
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="givenName">Adı: </Label>
                                <Col sm={12}>
                                    <Input type="text"
                                           name="givenName"
                                           disabled={!this.state.disableFormattedName}
                                           value={this.state.chemistInformation.givenName}
                                           onChange={(e) => this.onChange("givenName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="familyName">Soyadı: </Label>
                                <Col sm={12}>
                                    <Input type="text"
                                           name="familyName"
                                           disabled={!this.state.disableFormattedName}
                                           value={this.state.chemistInformation.familyName}
                                           onChange={(e) => this.onChange("familyName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row sm="12">
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10}>Nace Kodu: *</Label>
                                <Col sm={12}>
                                    <Select.Async multi
                                                  value={this.prepareNaceCodesSelectData(this.state.chemistInformation.naceCodes)}
                                                  valueRenderer={(e) => {
                                                      return e.customValue;
                                                  }}
                                                  onChange={(e) => this.onChangeNaceCodes(e)}
                                                  isLoading={true}
                                                  autoload={false}
                                                  cache={false}
                                                  clearable={false}
                                                  arrowRenderer={this.arrowRenderer}
                                                  noResultsText="Kayıt bulunamadı."
                                                  searchPromptText="Arama için en az 1 karakter giriniz."
                                                  placeholder="NACE kodu veya açıklaması ile arama yapabilirsiniz"
                                                  loadingPlaceholder="Yükleniyor..."
                                                  loadOptions={getNaceCodes}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="corporateMail">Kurumsal e-posta: </Label>
                                <Col sm={12}>
                                    <MaskedInput className="form-control"
                                                 type="text"
                                                 name="corporateMail"
                                                 mask={emailMask}
                                                 placeholder="_________@______.___"
                                                 value={this.state.chemistInformation.corporateMail}
                                                 onChange={(e) => this.onChange("corporateMail", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="city">Vergi Dairesinin Bulunduğu İl: *</Label>
                                <Col sm={12}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        value={this.state.chemistInformation.city}
                                        placeholder="Seçiniz..."
                                        name="city"
                                        onChange={(e) => this.onChange("city", e.value)}
                                        options={this.state.cityList.map(city => ({
                                            value: city.cityName,
                                            label: city.cityName
                                        }))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="taxOffice">Vergi Dairesi: *</Label>
                                <Col sm={12}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        name="taxOffice"
                                        value={this.state.chemistInformation.taxOffice}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onChange("taxOffice", e.value)}
                                        options={this.state.filteredTaxOfficeList.map(to => ({
                                            value: to.vdName,
                                            label: to.vdName
                                        }))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="sorumluCepTel">Sorumlu Cep Tel. </Label>
                                <Col sm={12}>
                                    <MaskedInput className="form-control"
                                                 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                                 placeholder="+90__________"
                                                 type="text"
                                                 name="sorumluCepTel"
                                                 value={this.state.chemistInformation.sorumluCepTel}
                                                 onChange={(e) => this.onChange("sorumluCepTel", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="sorumluEPosta">Sorumlu e-Posta</Label>
                                <Col sm={12}>
                                    <MaskedInput className="form-control"
                                                 mask={emailMask}
                                                 placeholder="_________@______.___"
                                                 type="text"
                                                 name="sorumluEPosta"
                                                 value={this.state.chemistInformation.sorumluEPosta}
                                                 onChange={(e) => this.onChange("sorumluEPosta", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="application">Kullandığınız Eczane Otomasyon Uygulaması: *</Label>
                                <Col sm={12}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        value={this.state.chemistInformation.application}
                                        placeholder="Seçiniz..."
                                        name="application"
                                        onChange={(e) => this.onChange("application", e.value)}
                                        options={this.state.applicationList.map(al => ({
                                            value: al.value,
                                            label: al.label
                                        }))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        {"DIGER" === this.state.chemistInformation.application &&
                            <Col sm={6}>
                                <FormGroup row>
                                    <Label sm={10} for="applicationOther">Diğer Uygulama: *</Label>
                                    <Col sm={12}>
                                        <Input type="text"
                                               name="applicationOther"
                                               value={this.state.chemistInformation.applicationOther}
                                               onChange={(e) => this.onChange("applicationOther", e.target.value)}/>
                                    </Col>
                                </FormGroup>
                            </Col>}
                    </Row>

                    {this.renderBankInput()}
                </Col>
            </DefaultModal>
        )
    }
}

export default ChemistInformationModal;